import React from 'react';

const StudentTesting1 = () => {
  return <div>Student Status</div>;
};

export default StudentTesting1;
